import { authentication } from "@/services/auth";
import { Device } from "@/services/Device";
import { responses } from "@/utils/responses";
import Swal from "sweetalert2";
import Vue from 'vue'
import { utils } from "@/utils/utils";
import { errorHandler } from "@/services/errorHandler";
import queryStringify from "qs-stringify";
import store from "@/store";
import html2canvas from 'html2canvas';
import { dateTimeManager } from "@/services/TimeManager";
window.getBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
import axios from "axios";
window.axios = axios;
Vue.prototype.$dateTimeManager = dateTimeManager;
// === AB#5178: lytningtomcat base URLs are build-time env-driven ===
// Every lytningtomcat URL below resolves via process.env.VUE_APP_API_* at build
// time. .env.production sets Live values; .env.staging sets Test_* where a Test_*
// twin exists on lytningtomcat.chrilantech.com. The trailing-string fallback is
// the Live URL — the bundle always renders to Live if the env var is missing
// (matches the production safety default). See
// docs/design-docs/2026-08-05-env-driven-api-urls.md.
// Other domains (lna.pos.co.zm, chrilantech.com, server.shop.co.zm,
// realtime.abc.co.zm) stay hardcoded — out of scope.
// Live env: OnlineSalesServer/Franchise_OnlineServer/Lyt-SoftBackOfficeApi/OnlinePrintService
// Staging env: Test_* prefixed where the host provides a Test_* twin
window.serverApi = process.env.VUE_APP_API_SERVER || `https://lytningtomcat.chrilantech.com/OnlineSalesServer/`

window.ticketApi = `https://lna.pos.co.zm/TicketApp/`
//window.ticketApi = `http://kabs:8080/TicketApp/`;

window.kazangSubscriptionApi = `https://lna.pos.co.zm/kazangApi/api/`
// window.kazangSubscriptionApi = `http://192.168.1.142:8286/kazangApi/api/`

window.kazangApi = `https://lna.pos.co.zm/kazangApi/api/`
// window.kazangApi = `http://192.168.1.244:8181/kazangApi/api/`

window.gateWayApi = `https://realtime.abc.co.zm:8443/SandboxKazangPaymentGateway/api/GateWay/`
// window.gateWayApi = `http://192.168.1.225:9333/KazangPaymentGateway/api/GateWay/`


window.lytstoreApi = `https://server.shop.co.zm/lyt-store/v1/stores`
//window.lytstoreApi = `http://mcc:8283/lyt-store/v1/stores`


// Live env: Franchise_OnlineServer
// Staging env: Test_Franchise_OnlineServer
window.franchiseTomcatApi = process.env.VUE_APP_API_FRANCHISE || `https://lytningtomcat.chrilantech.com/Franchise_OnlineServer/`
// window.franchiseTomcatApi = `http://DESKTOP-JS3P555:7082/Franchise_OnlineServer/`

// Stock image host returns image bytes directly (preferred over spring redirect endpoint).
// Shares the Franchise_OnlineServer base — same env var as franchiseTomcatApi.
window.stockImageApiBase = process.env.VUE_APP_API_FRANCHISE || `https://lytningtomcat.chrilantech.com/Franchise_OnlineServer/`
// window.stockImageApiBase = `http://DESKTOP-JS3P555:7082/Franchise_OnlineServer/`

// Live env: loyalty_service/loyalty (no Test_* twin on this host)
window.loyaltyApi = process.env.VUE_APP_API_LOYALTY || `https://lytningtomcat.chrilantech.com/loyalty_service/loyalty/`
// window.loyaltyApi = `http://192.168.1.244:8181/loyalty_service/loyalty/`

window.zedMobileApi = `https://lna.pos.co.zm/ZedMobileApi/`
// window.zedMobileApi = `http://localhost:8181/ZedMobileApi/`

// Live env: Lyt-SoftBackOfficeApi
// Staging env: Test_Lyt-SoftBackOfficeApi
window.backOfficeTomcatApi = process.env.VUE_APP_API_BACKOFFICE || `https://lytningtomcat.chrilantech.com/Lyt-SoftBackOfficeApi/`
// window.backOfficeTomcatApi = `http://DESKTOP-JS3P555:7083/Lyt-SoftBackOfficeApi/`

window.synergyApi = `https://lna.pos.co.zm/SynergyApi/api/v1/`
// window.synergyApi = `http://loretta:8181/SynergyApi/api/v1/`

window.announcementsApi = `${window.synergyApi}announcements`

// Live env: SubscriptionManager/api (no Test_* twin on this host)
window.subscriptionApi = process.env.VUE_APP_API_SUBSCRIPTION || `https://lytningtomcat.chrilantech.com/SubscriptionManager/api/`
// window.subscriptionApi = `https:///subscription/api/`

// Live env: OnlinePrintService
// Staging env: Test_OnlinePrintService
window.printVoid = process.env.VUE_APP_API_PRINT_VOID || `https://lytningtomcat.chrilantech.com/OnlinePrintService/`
// window.printVoid = `http://DESKTOP-JS3P555:7084/OnlinePrintService/`

// Live env: PrintApi (no Test_PrintApi — test installer comment: "printApi stays LIVE")
window.printApi = process.env.VUE_APP_API_PRINT || `https://lytningtomcat.chrilantech.com/PrintApi/`
// window.printApi = `https://lytningtomcat.chrilantech.com/Test_PrintApi/`

window.backOfficeApiPOST = franchiseTomcatApi + `proxyApi/lytSoftBackOffice/POST`;
window.backOfficeApiGET = franchiseTomcatApi + `proxyApi/lytSoftBackOffice/GET`;

window.androidMode = false;

// window.backOfficePlatform = `http://192.168.0.220:8082`;
window.backOfficePlatform = `https://admin.chrilantech.com`;

// Local Hardware Service removed: no window.hardwareApi
window.smartinvoicesearch = backOfficeTomcatApi + `other/`;
window.gateWayApiPOST = franchiseTomcatApi + `proxyApi/gateWay/POST`;
window.gateWayApiGET = franchiseTomcatApi + `proxyApi/gateWay/GET`;

window.subscriptionApiPOST = franchiseTomcatApi + `proxyApi/subscriptionApi/POST`;
window.subscriptionApiGET = franchiseTomcatApi + `proxyApi/subscriptionApi/GET`;

window.franchiseApi = `https://chrilantech.com/LytSoftPosOnline/api/`
// Live env: lytningtomcat base host (no service suffix)
// Staging env: same host — Test_* is per-service, not per-host
window.franchiseApiLytning = process.env.VUE_APP_LYTNING_TOMCAT_BASE || `https://lytningtomcat.chrilantech.com/`
// window.franchiseApi = `http://127.0.0.1:8000/api/`

// Live env: FranchiseSpringServer (no Test_* twin on this host)
window.franchiseSpringApi = process.env.VUE_APP_API_FRANCHISE_SPRING || `https://lytningtomcat.chrilantech.com/FranchiseSpringServer/`

// Live env: ReportsApi (no Test_* twin for the legacy ReportsApi/ used by Retail POS;
// Analytics owns the Test_ReportsApi/api/v2/ staging variant on its own .env.staging)
window.reportTomcatApi = process.env.VUE_APP_API_REPORTS || `https://lytningtomcat.chrilantech.com/ReportsApi/`;
window.reportsApi = reportTomcatApi + `api/v2/cashup/`

window.auth = authentication;
window.Device = Device;
window.responses = responses;
window.errorHandler = errorHandler
window.routeExceptions = ['login', 'forgot-password', 'kazangOnline', 'test-success', 'test-failed', 'initKazangOnline',
    'signup', 'custom-install', 'custom-cart', 'validation', 'SelectUserView', 'OtpView', 'customer-display'];

const EventBus = new Vue()
window.EventBus = EventBus
window.log = (val) => console.log(val);
window.Swal = Swal;

window.generateUUID = () => {
    let uuid = '', i, random;
    for (i = 0; i < 32; i++) {
        random = Math.random() * 16 | 0;
        if (i === 8 || i === 12 || i === 16 || i === 20) {
            uuid += '-';
        }
        uuid += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random)).toString(16);
    }
    return uuid;
}

window.$utils = utils;


window.screenShot = async () => {
    Swal.close();
    let sheet = store.getters.getActiveSheet;
    if (sheet) {
        try {
            await sheet.close();
            await new Promise(resolve => setTimeout(resolve, 300));
        } catch (r) {
        }
    }
    return html2canvas(document.body, { logging: false }).then(canvas => {
        let data = canvas.toDataURL('image/png');
        return data.split(';base64,')[1]
    }).catch(err => {
        console.error(err);
    }).finally(async () => {
        if (sheet) {
            try {
                await sheet.open();
            } catch (w) {
            }
        }
    });
}

Vue.prototype.$utils = utils;

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1500,
    showCloseButton: true,
    customClass: 'toastr',
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});
window.Toast = Toast;
window.stringify = (object) => queryStringify(object);



window.pageOptions = {
    enabled: true,
    mode: 'pages',
    perPage: 10,
    position: 'bottom',
    perPageDropdown: [10, 100, 200],
    dropdownAllowAll: false,
    jumpFirstOrLast: true,
    pageLabel: 'page',
}
window.openUrl = (url, target = '_blank') => window.open(url, target, "_blank", "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=no, copyhistory=yes, width=900, height=700");
window.encryptObj = (object) => window.btoa(JSON.stringify(object));
window.decryptObj = (string) => window.atob(JSON.parse(string));

window.isValidString = (string) => {
    if (!string) return false;
    string = string.toString().trim();
    return !(string === `null` || string === `undefined` || string === ``);

}

window.scaleSettings = {
    comPort: 'COM2',
    baudRate: 9600,
    dataBits: 8,
    stopBits: 1,
    parity: 'none'
};

// =====================================================================
// Autosigner (in-app update distribution) — see docs/exec-plans/active/
// 2026-06-23-app-update-flow.md
// ---------------------------------------------------------------------
// The downloader key is read here so the renderer can publish which
// channel/app/platform to check. The privileged HTTPS call itself is
// ALWAYS performed by the Electron main process; the renderer never
// makes the bearer-authenticated request directly. See
// electron/autoUpdater.js and the `updateAPI` exposed in preload.js.
// =====================================================================
window.autosignerApi = 'https://autosigner.abc.co.zm/v1/api';
window.autosignerAppId = 'lytning';
// Platform is derived from process.platform in the Electron main
// process. The renderer-facing constant is for documentation only.
window.autosignerPlatform = 'windows';
// Downloader API key (downloads only, never admin or uploader).
// NOTE: this constant currently lives in the renderer bundle. Follow-up
// is to move the key to app.getPath('userData')/autosigner-config.json
// so it never enters the renderer bundle. The `updateAPI` contract
// does not need to change.
window.autosignerDownloaderKey = 'REPLACE_WITH_AUTOSIGNER_DOWNLOADER_KEY';
